import React, { useEffect, useState, createContext, useCallback } from 'react';
import ModalProfessionalSchedule from './components/ModalProfessionalSchedule';
import ModalScheduleCreate from './components/ModalScheduleCreate';
import TableWeekHeader from './components/TableWeekHeader';
import TableWeekContent from './components/TableWeekContent';
import Layout from 'shared/component/Layout';
import InputSearchModal from 'shared/component/inputSearchModal';
import FilterShiftsModal from 'shared/component/FilterShiftsModal';
import { Typography, CircularProgress } from '@material-ui/core';
import { styles } from './styles';
import { useUnitScales } from 'hook/unitScales';
import { useConfig } from 'hook/config';
import { useAgenda } from 'hook/agenda';
import { useAgendaDetails } from 'hook/agenda/details';
import ControlledPagination from 'shared/component/ControledPagination';
import usePersistedState from 'hook/usePersistedState';
import { useAgendaValuePrice } from 'hook/agenda/value_price';
import moment from 'moment';
import { TableLegend } from 'shared/component/TableLegend';
import debounce from 'lodash/debounce'; // Instale lodash se ainda não estiver instalado
import TableHoursWeek from './components/TableHoursWeek';

export const ScheduleWeekPageContext = createContext({});

function WeekSchedule() {
  const classes = styles();
  const { config } = useConfig();

  const permissions = {
    read: 'schedule/r',
    create: 'schedule/c',
    delete: 'schedule/d',
    update: 'schedule/u',
    validate: 'schedule/validate',
    export: 'schedule/export',
    changeProfessional: 'schedule/change-professional',
    value: 'scheduleValue/r',
    changeValue: 'schedule/change-value',
  };

  const {
    loading: loadingUnitScales,
    data: dataUnitScales,
    total: totalUnitScales,
    getUnitScales,
  } = useUnitScales();

  const {
    loading: loadingAgenda,
    data: dataUnitAgenda,
    total: totalAgenda,
    getAgenda,
    createAgenda,
    getHoursByScale,
    hoursData,
    loading: loadingHoursWeek,
    totalHours,
  } = useAgenda();

  const {
    data: agendaDetails,
    loading: loadingAgendaDetails,
    setData: setAgendaDetailsData,
    getAgendaDetails,
  } = useAgendaDetails();

  const { data: dataValue, getAgendaValuePrice } = useAgendaValuePrice();

  const scaleLocal = localStorage && localStorage.getItem('selectedScale');
  const scaleJsonInLocal =
    localStorage.getItem('selectedScale') && JSON.parse(scaleLocal);
  const scaleInArray = scaleJsonInLocal ? scaleJsonInLocal : [];
  const [hoursPage, setHoursPage] = useState(1);
  const perPageHours = 10;
  const [openModalScheduleCall, setOpenModalScheduleCall] = useState(false);
  const [openModalSchedule, setOpenModalSchedule] = useState(false);
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const selectedLocalUnit = localStorage.getItem('selectedLocalUnit');
  const parseSelectedUnit = selectedLocalUnit && JSON.parse(selectedLocalUnit);
  const [selectedUnit, setSelectedUnit] = useState(
    parseSelectedUnit ? parseSelectedUnit : null
  );
  const [stateScales, setStateScales] = useState(scaleInArray);
  const [detailsSchedule, setDetailsSchedule] = useState(null);
  const [currentTab, setCurrentTab] = usePersistedState(
    'plantaoextra@tabshopital',
    { value: 0 }
  );

  const findSelectedScale =
    selectedUnit && scaleInArray.find((item) => item.unit === selectedUnit.id);

  const firstWeekDay = moment().day(1);
  const lastWeekDay = moment().day(7);
  const initialMainFilter = {
    date_start: moment(firstWeekDay).format('YYYY-MM-DD'),
    date_end: moment(lastWeekDay).format('YYYY-MM-DD'),
    unit_id: selectedUnit ? selectedUnit.id : '',
    scale_id: findSelectedScale ? findSelectedScale.value : null,
    page: 1,
    search: '',
  };

  const [mainFilter, setMainFilter] = useState(initialMainFilter);

  // Debounce para evitar chamadas duplicadas
  const debouncedGetAgenda = useCallback(
    debounce((filters) => {
      getAgenda(filters);
    }, 300),
    []
  );

  // Memoizar handleGetAgenda
  const handleGetAgenda = useCallback(() => {
    const { unit_id, date_start, date_end } = mainFilter;
    if (!openFilter && unit_id && date_start && date_end) {
      debouncedGetAgenda({ ...mainFilter, scale_name: null, scales: null });
    }
  }, [mainFilter, openFilter]);

  useEffect(() => {
    handleGetAgenda();
  }, [mainFilter, openFilter]);

  useEffect(() => {
    !mainFilter?.scale_id &&
      mainFilter?.unit_id &&
      setMainFilter(initialMainFilter);
  }, [mainFilter?.unit_id]);

  useEffect(() => {
    const setConfigsProps = () => {
      const firstUnitOnConfig = config?.hospitalData[currentTab.value];
      if (config?.hospitalData && !selectedUnit) {
        setSelectedUnit(firstUnitOnConfig);
        setMainFilter((oldState) => ({
          ...oldState,
          unit_id: firstUnitOnConfig?.id,
        }));
        getUnitScales(firstUnitOnConfig?.id);
      }
    };
    setConfigsProps();
  }, [config]);

  useEffect(() => {
    !mainFilter?.scale_id && setOpenFilter(true);
  }, [currentTab, findSelectedScale]);

  useEffect(() => {
    if (config.hospitalData.length <= 2) {
      setCurrentTab({ value: 0 });
      handleClickUnitTab(config.hospitalData[0]);
    }
  }, [config]);

  useEffect(() => {
    if (
      mainFilter?.scale_id &&
      mainFilter?.date_start &&
      mainFilter?.date_end
    ) {
      getHoursByScale({
        scale_id: mainFilter.scale_id,
        date_start: mainFilter.date_start,
        date_end: mainFilter.date_end,
        page: hoursPage,
        per_page: perPageHours,
      });
    }
  }, [
    mainFilter?.scale_id,
    mainFilter?.date_start,
    mainFilter?.date_end,
    hoursPage,
  ]);
  const [localScales, setLocalScales] = useState('');

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleOpenSearchModal = () => {
    setOpenSearchModal(true);
  };

  const handleCloseSearchModal = () => {
    setOpenSearchModal(false);
  };

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handlePageChange = (page) => {
    setMainFilter((oldState) => ({
      ...oldState,
      page,
    }));
  };

  const handleCloseChipScale = (filterDelete) => () => {
    // Remove o item da lista
    const updatedScaleInArray = scaleInArray.filter(
      (item) => item.value !== filterDelete.value
    );
    localStorage.setItem('selectedScale', JSON.stringify(updatedScaleInArray));

    // Atualiza o estado local
    setStateScales(updatedScaleInArray);

    // Atualiza o filtro principal
    setMainFilter((prevFilter) => ({
      ...prevFilter,
      scale_id:
        updatedScaleInArray.length > 0 ? updatedScaleInArray[0]?.value : null,
      scale_name:
        updatedScaleInArray.length > 0 ? updatedScaleInArray[0]?.label : null,
    }));

    // Verifica se ainda existem chips restantes
    if (updatedScaleInArray.length === 0) {
      setOpenFilter(true); // Abre o FilterShiftsModal apenas se todos os chips forem removidos
    }

    // Dispara o request com o filtro atualizado
    debouncedGetAgenda({
      ...mainFilter,
      scale_id:
        updatedScaleInArray.length > 0 ? updatedScaleInArray[0]?.value : null,
      scale_name:
        updatedScaleInArray.length > 0 ? updatedScaleInArray[0]?.label : null,
    });
  };
  const handleChangeTab = (event, newTab) => {
    setCurrentTab({ ...currentTab, value: newTab });
  };

  const handleClickUnitTab = (unit) => {
    const { id } = unit;

    // Atualiza o hospital selecionado
    setSelectedUnit(unit);

    // Atualiza o localStorage da unidade
    localStorage.setItem('selectedLocalUnit', JSON.stringify(unit));

    // Busca a primeira escala do hospital no estado ou localStorage
    // Atualize scaleInArray de acordo com a unidade atual
    const scalesForUnit = scaleInArray.filter((item) => item.unit === id);
    const firstScale = scalesForUnit.length > 0 ? scalesForUnit[0] : null;

    // Atualiza localStorage da escala selecionada (para manter o padrão)
    if (firstScale) {
      localStorage.setItem('selectedScale', JSON.stringify([firstScale]));
    } else {
      localStorage.removeItem('selectedScale');
    }

    // Atualiza o filtro principal com hospital e escala (ou null se não tiver escala)
    setMainFilter((old) => ({
      ...old,
      unit_id: id,
      scale_id: firstScale ? firstScale.value : null,
      scale_name: firstScale ? firstScale.label : null,
      page: 1,
    }));

    // Opcional: você pode atualizar o stateScales para refletir as escalas atuais
    setStateScales(scalesForUnit);
  };

  const handleOpenModalScheduleCall = ({
    scaleData,
    schedule,
    selected_schedule,
    agenda,
    daySelected,
  }) => {
    setOpenModalScheduleCall(true);
    setDetailsSchedule({
      schedule,
      selected_schedule,
      agenda,
      scaleData,
      daySelected,
    });
  };

  const handleCloseModalScheduleCall = () => {
    setOpenModalScheduleCall(false);

    // Atualiza as horas na tabela da semana
    if (
      mainFilter?.scale_id &&
      mainFilter?.date_start &&
      mainFilter?.date_end
    ) {
      getHoursByScale({
        scale_id: mainFilter.scale_id,
        date_start: mainFilter.date_start,
        date_end: mainFilter.date_end,
      });
    }
  };

  const handleDateChange = ({ date_start, date_end }) => {
    localStorage.setItem(
      'scheduleWeekDate',
      JSON.stringify({ date_start, date_end })
    );
    setMainFilter((oldState) => ({
      ...oldState,
      date_start,
      date_end,
    }));
  };

  const handleOpenSchedule = useCallback(({ item, scaleData }) => {
    setOpenModalSchedule(true);
    getAgendaDetails({ agenda_id: item?.id });
    getAgendaValuePrice({ agenda_id: item?.id });
    setDetailsSchedule({
      ...item,
      scaleData,
    });
  }, []);

  let schedule = useState(JSON.parse(localStorage.getItem('selectedScale')));
  if (schedule[0] == null || schedule[0].length === 0) {
    schedule = false;
  } else {
    schedule = true;
  }

  return (
    <Layout
      handleDateChange={handleDateChange}
      title="Agenda da semana"
      backArrow
    >
      <ScheduleWeekPageContext.Provider
        value={{
          localScales,
          setLocalScales,
          scaleInArray,
          findSelectedScale,
          scaleJsonInLocal,
          dataUnitAgenda,
          openModalSchedule,
          openModalScheduleCall,
          currentTab,
          stateScales,
          mainFilter,
          openSearchModal,
          dataUnitScales,
          openFilter,
          intialMainFilter: initialMainFilter,
          loadingUnitScales,
          totalUnitScales,
          selectedUnit,
          detailsSchedule,
          agendaDetails,
          dataValue,
          loadingAgendaDetails,
          setAgendaDetailsData,
          handleGetAgenda,
          handleOpenSchedule,
          getAgendaDetails,
          getUnitScales,
          createAgenda,
          getAgenda,
          handleCloseModalScheduleCall,
          handleCloseFilter,
          setStateScales,
          setMainFilter,
          handleCloseSearchModal,
          handleOpenSearchModal,
          handleOpenFilter,
          handleCloseChipScale,
          handleChangeTab,
          handleClickUnitTab,
          handleOpenModalScheduleCall,
          setOpenModalSchedule,
          getHoursByScale,
        }}
      >
        <TableWeekHeader />
        {loadingAgenda && (
          <div style={{ textAlign: 'center', marginTop: '21%' }}>
            <CircularProgress color="primary" size={120} />
          </div>
        )}
        {mainFilter?.scale_id &&
          !loadingAgenda &&
          dataUnitAgenda &&
          dataUnitAgenda.length > 0 &&
          dataUnitAgenda.map((data, index) => (
            <TableWeekContent
              permissions={permissions}
              key={index}
              data={data}
            />
          ))}
        {!findSelectedScale && !loadingAgenda && (
          <div className={classes.container_no_results}>
            <Typography className={classes.no_results}>
              Selecione uma escala!
            </Typography>
          </div>
        )}
        {findSelectedScale && !loadingAgenda && dataUnitAgenda.length === 0 && (
          <div className={classes.container_no_results}>
            <Typography className={classes.no_results}>
              Sem resultados para essa Escala ou data!
            </Typography>
          </div>
        )}
        <div className={classes.container_pagination}>
          <ControlledPagination
            onChange={handlePageChange}
            total={totalAgenda}
            perPage={mainFilter?.per_page}
            loading={loadingAgenda}
          />
        </div>
        <TableLegend />
        <div className={classes.tableHour}>
          <TableHoursWeek
            data={hoursData}
            loading={loadingHoursWeek}
            page={hoursPage}
            perPage={perPageHours}
            onChangePage={setHoursPage}
            dateStart={mainFilter.date_start}
            dateEnd={mainFilter.date_end}
            total={totalHours} // <-- total geral da API
          />
        </div>
        <ModalProfessionalSchedule permissions={permissions} />
        <ModalScheduleCreate />
        <InputSearchModal currentContext={ScheduleWeekPageContext} />
        <FilterShiftsModal
          open={!!dataUnitAgenda.length}
          currentContext={ScheduleWeekPageContext}
          onlyOneScale
          buttonFilter
          buttonDuplicate
        />
      </ScheduleWeekPageContext.Provider>
    </Layout>
  );
}

export default WeekSchedule;
